var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.$store.getters.isLoggedIn &&
      _vm.purchase.actions.customer.select_winner &&
      _vm.purchase.private_data &&
      _vm.purchase.private_data.winner_selection &&
      _vm.purchase.status.id === "summarizing"
        ? [
            _vm.purchase.private_data.proposals &&
            _vm.purchase.private_data.proposals.length > 0
              ? [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { md: "10" } }, [
                        _c(
                          "h2",
                          { staticClass: "grey-color font-weight-bold my-3" },
                          [_vm._v("Предложения участников")]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._l(
                    _vm.purchase.private_data.proposals,
                    function (proposal, index) {
                      return _c(
                        "private-commercial-winner-selection-proposal-card",
                        {
                          key: "proposal_" + index,
                          attrs: {
                            proposal: proposal,
                            "purchase-id": _vm.purchase.id,
                            "supplier-requirements":
                              _vm.purchase.supplier_requirements,
                            purchase: _vm.purchase,
                            index: index,
                            "with-rating": true,
                            confirmed:
                              _vm.purchase.private_data.winner_selection
                                .confirmed,
                            "proposal-selected": _vm.winnerProposalsSelected,
                          },
                          on: { refresh: _vm.refresh },
                          model: {
                            value: proposal.rating,
                            callback: function ($$v) {
                              _vm.$set(proposal, "rating", $$v)
                            },
                            expression: "proposal.rating",
                          },
                        }
                      )
                    }
                  ),
                  _c("commercial-purchase-store-winner-selection-button", {
                    attrs: {
                      purchase: _vm.purchase,
                      ratings: _vm.proposalRatings,
                      proposals: _vm.purchase.private_data.proposals,
                    },
                    on: { store: _vm.refresh },
                  }),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.$store.getters.isLoggedIn &&
      _vm.purchase.actions.customer.select_winner &&
      _vm.purchase.private_data &&
      _vm.purchase.private_data.winner_selection &&
      _vm.purchase.private_data.winner_selection.confirmed &&
      _vm.purchase.status.id === "summarizing"
        ? [
            _c("text-header", [_vm._v("Итоговый протокол закупочной сессии")]),
            _c(
              "a",
              {
                staticClass: "btn btn-custom-green text-uppercase",
                attrs: {
                  href: _vm.purchase.private_data.winner_selection
                    .protocol_template_link,
                },
              },
              [_vm._v("Скачать итоговый протокол закупочной сессии")]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }